"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsiveMobileStyles = exports.multilineUnderline = exports.clampText = exports.ellipsis = exports.isElementInViewport = exports.mediaQuery = exports.getBreakPoint = exports.innerShadow0 = exports.boxShadow1 = exports.boxShadow0 = exports.transition = void 0;
var styled_components_1 = require("styled-components");
var _EXPORTS_1 = require("../../utils/_EXPORTS");
var transitions_1 = require("./transitions");
Object.defineProperty(exports, "transition", { enumerable: true, get: function () { return transitions_1.transition; } });
var boxShadows_1 = require("./boxShadows");
Object.defineProperty(exports, "boxShadow0", { enumerable: true, get: function () { return boxShadows_1.boxShadow0; } });
Object.defineProperty(exports, "boxShadow1", { enumerable: true, get: function () { return boxShadows_1.boxShadow1; } });
Object.defineProperty(exports, "innerShadow0", { enumerable: true, get: function () { return boxShadows_1.innerShadow0; } });
var getBreakPoint = function (point) {
    switch (point) {
        case "xs":
            return 0;
        case "sm":
            return 600;
        case "md":
            return 800;
        case "lg":
            return 1000;
        case "xl":
            return 1300;
        case "xxl":
            return 1600;
        default:
            throw new Error("Invalid breakpoint");
    }
};
exports.getBreakPoint = getBreakPoint;
var mediaQuery = function (point) {
    return "@media only screen and (min-width: ".concat((0, exports.getBreakPoint)(point), "px)");
};
exports.mediaQuery = mediaQuery;
// Unused
var isElementInViewport = function (el) {
    if (!el)
        return false;
    var rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
exports.isElementInViewport = isElementInViewport;
exports.ellipsis = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
/**
 * Generates a CSS rule to clamp the number of lines of text displayed.
 *
 * @param {number} noOfLines - The number of lines of text to display.
 * @return {FlattenInterpolation<ThemedStyledProps<any, any>>} The generated CSS rule.
 */
var clampText = function (noOfLines) { return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"], ["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"])), noOfLines); };
exports.clampText = clampText;
/**
 * Creates CSS rules to add a multiline underline effect on an inline element.
 *
 * @param {Object} props - The properties of the element to apply the multiline underline effect to.
 * @param {string} props.color - The color of the underline.
 * @param {string} [props.thickness=1px] - The thickness of the underline.
 * @param {boolean} [props.reverse=false] - Whether to reverse the direction of the underline.
 * @return {{init: FlattenInterpolation<any>, hovered: FlattenInterpolation<any>}} The CSS rules to apply.
 */
var multilineUnderline = function (_a) {
    var color = _a.color, _b = _a.thickness, thickness = _b === void 0 ? "1px" : _b, _c = _a.reverse, reverse = _c === void 0 ? false : _c;
    return ({
        init: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-image: linear-gradient(", ", ", ");\n    background-repeat: no-repeat;\n    background-position: left bottom;\n    background-size: ", " ", ";\n  "], ["\n    background-image: linear-gradient(", ", ", ");\n    background-repeat: no-repeat;\n    background-position: left bottom;\n    background-size: ", " ", ";\n  "])), color, color, reverse ? "100%" : "0%", thickness),
        hovered: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background-size: ", " ", ";\n  "], ["\n    background-size: ", " ", ";\n  "])), reverse ? "0%" : "100%", thickness),
    });
};
exports.multilineUnderline = multilineUnderline;
var useResponsiveMobileStyles = function (reponsive) {
    if (reponsive === void 0) { reponsive = false; }
    if (!reponsive)
        return false;
    var screenWidth = (0, _EXPORTS_1.useScreenWidth)();
    return reponsive && screenWidth < (0, exports.getBreakPoint)("sm");
};
exports.useResponsiveMobileStyles = useResponsiveMobileStyles;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
